// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3kGUS","sendOtp":"AuthorizeToLogin_sendOtp__2tfwU"};